module.exports = __webpack_public_path__ + "static/img/chuji.100755cf.png";